import type { FC } from "react";

import { Stack, Typography } from "@mui/material";
import CustomDropdown from "../../../CustomDropdown";
import CustomSwitch from "../../../CustomSwitch";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface RulesTabShoptetLastOrdersCaseProps {
  dropdownTimeRanges?: { title: string; value: string }[];
  selectedTimeRange?: string;
  withRepeat: boolean;
  onToggleWithRepeat: () => void;
  onChangeTimeRange?: (value: string) => void;
}

export const RulesTabShoptetLastOrdersCase: FC<
  RulesTabShoptetLastOrdersCaseProps
> = ({
  dropdownTimeRanges,
  selectedTimeRange,
  withRepeat,
  onToggleWithRepeat,
  onChangeTimeRange,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <Stack direction='row' sx={{ width: 1, mt: 2 }}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          sx={{ width: 1 }}
        >
          <Typography
            fontSize={14}
            color={theme.palette.natural.t1}
          ></Typography>
          {dropdownTimeRanges && (
            <CustomDropdown
              label={t("campaign.notifications.shoptetLastOrders.showRandom")}
              items={dropdownTimeRanges.map(item => ({
                ...item,
                title: t(item.title),
              }))}
              disabled
              onChange={e =>
                onChangeTimeRange && onChangeTimeRange(e.target.value)
              }
              value={selectedTimeRange}
              width='100%'
            />
          )}
        </Stack>
      </Stack>
      <Stack>
        <Stack direction='row' sx={{ width: 1 }}>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            sx={{ width: 1 }}
          >
            <Typography fontSize={14} color={theme.palette.natural.t1}>
              {t(
                "campaign.notifications.settings.displayRules.repeatNotification",
              )}
            </Typography>
            <CustomSwitch checked={withRepeat} onSwitch={onToggleWithRepeat} />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
